export const NEAR_TOP_SCROLL_THRESHOLD_PX = 200;
